module.exports = __webpack_public_path__ + "img/sync-paket.48b27365.svg";